import React from 'react';
import { Button } from 'primereact/button';

interface GlobalHeaderButton {
  label?: string;
  icon?: string;
  onClick?: () => void;
  outlined?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
}

interface GlobalHeaderProps {
  title: string;
  subtitle: string;
  icon: string;
  buttons?: GlobalHeaderButton[];
  gradientFrom?: string;
  gradientTo?: string;
}

const GlobalHeaderTitle: React.FC<GlobalHeaderProps> = ({
  title,
  subtitle,
  icon,
  buttons = [],
  gradientFrom = '#4169E1',
  gradientTo = '#5B7CE6'
}) => {
  return (
    <div
      className="header-content"
      style={{
        background: 'white',
        borderRadius: '20px',
        padding: '20px 20px',
        marginBottom: '18px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        border: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '16px'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <div style={{
          width: '42px',
          height: '42px',
          background: `linear-gradient(135deg, rgb(30, 58, 138) 0%, rgb(59, 130, 246) 100%)`,
          borderRadius: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 12px rgba(65, 105, 225, 0.25)',
          flexShrink: 0
        }}>
          <i className={icon} style={{ fontSize: '18px', color: 'white' }}></i>
        </div>
        <div>
          <h1 style={{
            margin: 0,
            color: '#1f2937',
            fontSize: '17px',
            fontWeight: '600',
            letterSpacing: '-0.5px'
          }}>
            {title}
          </h1>
          <div style={{
            color: '#6b7280',
            fontSize: '12px',
            marginTop: '4px',
            fontWeight: '400'
          }}>
            {subtitle}
          </div>
        </div>
      </div>

      {buttons.length > 0 && (
        <div className="header-buttons" style={{ display: 'flex', gap: '10px' }}>
          {buttons.map((button, index) => (
            <Button
              key={index}
              label={button.label}
              icon={button.icon}
              onClick={button.onClick}
              className={button.outlined ? 'p-button-outlined action-btn' : 'action-btn'}
              disabled={button.disabled}
              style={{
                background: button.outlined
                  ? 'transparent'
                  : `linear-gradient(135deg, rgb(30, 58, 138) 0%, rgb(59, 130, 246) 100%)`,
                border: button.outlined ? '2px solid #4169E1' : 'none',
                borderRadius: '12px',
                padding: '10px 20px',
                fontSize: '12px',
                fontWeight: '500',
                boxShadow: button.outlined
                  ? 'none'
                  : '0 4px 12px rgba(65, 105, 225, 0.3)',
                ...button.style
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default GlobalHeaderTitle;
